import { useEffect, useState } from 'react'
import { Modal } from 'components'
import Label from 'components/forms/label'
import 'react-datepicker/dist/react-datepicker.css'
import InputDate from 'components/forms/input-date'
import moment from 'moment'
import { lang } from "config"
import useChartOfAccounts from 'repositories/source'
import ChartOfAccountCombobox from 'components/forms/chart-of-account-combobox'
import SelectDescription from 'components/forms/select-description'

const typeSelection = [
    {
        key: "petty-cash",
        label: "Petty Cash"
    },
    {
        key: "bill",
        label: "Bill"
    }
]

const transactionTypeSelection = [
    {
        key: "income",
        label: "Uang Masuk"
    },
    {
        key: "expense",
        label: "Uang Keluar"
    },
    {
        key: "internal-transfer",
        label: "Transfer Internal"
    }
]

const Content = ({ data, errors, onSubmit, onRemove }) => {
    const [source, setSource] = useState(data.source)
    const [type, setType] = useState(data.type)
    const [transactionType, setTransactionType] = useState(data.transactionType)
    const [from, setFrom] = useState(data.from)
    const [to, setTo] = useState(data.to)

    const { data: sourceSelection, isLoading: isLoadingSourceSelection } = useChartOfAccounts({
        type: 'source'
    }, `${process.env.REACT_APP_ACCOUNTING_API_URL}/chart-of-account`)

    const handleSubmit = (e) => {
        e.preventDefault()

        const data = {
            source_number: source,
            type,
            transaction_type: transactionType,
            from,
            to
        }

        // Filter before passing data to parent
        onSubmit(Object.fromEntries(Object.entries(data).filter(([_, v]) => v != null && v != '')))
    }

    return (
        <form onSubmit={handleSubmit} className="mt-8 space-y-8">
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                <div className="col-span-2">
                    <Label htmlFor="source" value={lang.source} />
                    <ChartOfAccountCombobox isLoading={isLoadingSourceSelection} selection={sourceSelection ?? []} onChange={(value) => setSource(value.number)} value={source} />
                </div>

                <div>
                    <Label htmlFor="type" value={lang.type} />
                    <SelectDescription onChange={(value) => setType(value)} selection={typeSelection} isLoading={false} value={type} keyValue={(value) => value.key} title={(value) => value.label} placeholder="Pilih Tipe" />
                </div>

                <div>
                    <Label htmlFor="transaction_type" value={lang.transaction_type} />
                    <SelectDescription onChange={(value) => setTransactionType(value)} selection={transactionTypeSelection} isLoading={false} value={transactionType} keyValue={(value) => value.key} title={(value) => value.label} placeholder="Pilih Tipe Transaksi" />
                </div>

                <div>
                    <Label htmlFor="from" value={lang.from} />
                    <InputDate id="from" maxDate={Date.parse(to)} onChange={(value) => setFrom(moment(value).format('Y-MM-DD'))} value={Date.parse(from)} selected={Date.parse(from)} />
                </div>

                <div>
                    <Label htmlFor="to" value={lang.to} />
                    <InputDate id="to" minDate={Date.parse(from)} onChange={(value) => setTo(moment(value).format('Y-MM-DD'))} value={Date.parse(to)} selected={Date.parse(to)} />
                </div>
            </div>
            <div className="flex items-center space-x-2 text-xs">
                <button type="submit" className="items-center px-6 py-3 text-white transition bg-neutral-800 rounded-xl active:hover:scale-90">
                    <span>{lang.filter}</span>
                </button>
                <button type="button" onClick={onRemove} className="items-center px-6 py-3 transition border border-neutral-200 bg-neutral-50 rounded-xl active:hover:scale-90">
                    <span>{lang.clear}</span>
                </button>
            </div>
        </form>
    )
}

const Filter = ({ data, errors, onSubmit, onRemove }) => {
    const [isOpen, setIsOpen] = useState(false)

    const openModal = () => setIsOpen(true)
    const closeModal = () => setIsOpen(false)

    const handleSubmit = (value) => {
        closeModal()
        onSubmit(value)
    }

    const handleRemove = () => {
        closeModal()
        onRemove()
    }

    return (
        <>
            <button onClick={openModal} className="inline-flex items-center px-4 py-3 space-x-2 transition border border-neutral-200 bg-neutral-50 rounded-xl active:hover:scale-90">
                <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" width={24} height={24} viewBox="0 0 24 24" strokeWidth={1} stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M5.5 5h13a1 1 0 0 1 .5 1.5l-5 5.5l0 7l-4 -3l0 -4l-5 -5.5a1 1 0 0 1 .5 -1.5"></path>
                </svg>
                <span>{lang.filter}</span>
                {Object.keys(data).length > 0 && (
                    <span className="inline-flex w-4 h-4 font-semibold rounded-full text-[0.5rem] justify-center text-neutral-200 bg-neutral-800">
                        {`${Object.keys(data).length}`}
                    </span>
                )}
            </button>
            <Modal isOpen={isOpen} onClose={closeModal} title={`${lang.filter} ${lang.data}`} content={<Content errors={errors} onSubmit={handleSubmit} onRemove={handleRemove} data={data} />} />
        </>
    )
}

export default Filter